import { render, staticRenderFns } from "./selectJoin.vue?vue&type=template&id=3ae3dff5"
import script from "./selectJoin.vue?vue&type=script&lang=js"
export * from "./selectJoin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports